import { AppConfigModel } from "../abstract/app-config.model";

export class PersonNameOrder extends AppConfigModel {

    static override CLASS_NAME: string = 'PersonNameOrder';
}
